import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import { mergeDefault } from '../_util';
import UiLoading from '../loading';
export default {
  name: 'UiToast',
  components: {
    UiLoading: UiLoading
  },
  data: function data() {
    return {
      show: false,
      options: {}
    };
  },
  props: {
    type: {
      type: String,
      default: 'default'
    },
    msg: String,
    animation: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 2
    },
    captureEvt: {
      type: Boolean,
      default: true
    },
    clickHide: {
      type: Boolean,
      default: true
    },
    withMask: Boolean,
    onClose: Function
  },
  methods: {
    renderStatusContent: function renderStatusContent() {
      var h = this.$createElement;

      if (this.options.type === 'success') {
        return [h("svg", {
          "class": "ui-toast-svg-icon",
          "attrs": {
            "viewBox": "0 0 48 48",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [h("path", {
          "attrs": {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "fill": "none",
            "d": "M36.528 7.145A20.906 20.906 0 0 0 24 3C12.402 3 3 12.402 3 24s9.402 21 21 21 21-9.402 21-21c0-3.785-1.001-7.336-2.754-10.403l-20.05 19.88-8.668-8.602",
            "stroke": "#FFF",
            "stroke-width": "2"
          }
        })]), h("p", {
          "class": "ui-toast-text"
        }, [this.options.msg || ''])];
      } else if (this.options.type === 'fail') {
        return [h("svg", {
          "class": "ui-toast-svg-icon",
          "attrs": {
            "viewBox": "0 0 48 48",
            "xmlns": "http://www.w3.org/2000/svg"
          }
        }, [h("path", {
          "attrs": {
            "fill": "none",
            "d": "M36.052 6.8c1 .703 1.936 1.49 2.797 2.35C42.65 12.952 45 18.202 45 24c0 11.598-9.402 21-21 21S3 35.598 3 24 12.402 3 24 3v21",
            "stroke": "#FFF",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }
        }), h("circle", {
          "attrs": {
            "fill": "#FFF",
            "cx": "24",
            "cy": "30",
            "r": "2"
          }
        })]), h("p", {
          "class": "ui-toast-text"
        }, [this.options.msg || ''])];
      } else {
        return h(UiLoading, {
          "attrs": {
            "size": "large",
            "color": "#fff",
            "tip": "加载中...",
            "customClassName": "ui-toast-loading"
          }
        });
      }
    },
    onMaskClick: function onMaskClick() {
      if (!this.options.withMask && this.options.clickHide) {
        this.hide();
      }
    },
    open: function open(options) {
      if (options === void 0) {
        options = {};
      }

      this.closeTimer && clearTimeout(this.closeTimer);
      this.options = mergeDefault(this.$props, options);
      this.show = true;

      if (this.options.duration) {
        this.closeTimer = setTimeout(this.hide, 1000 * this.options.duration);
      }
    },
    hide: function hide() {
      this.show = false;
      this.options.onClose && this.options.onClose();
      this.closeTimer && clearTimeout(this.closeTimer);
    },
    renderToast: function renderToast(node) {
      var h = this.$createElement;

      if (this.options.animation) {
        return h("transition", {
          "attrs": {
            "name": "toast-fade"
          }
        }, [node]);
      } else {
        return node;
      }
    }
  },
  created: function created() {
    this.options = _extends({}, this.$props);
  },
  render: function render(h) {
    var _this$options = this.options,
        type = _this$options.type,
        msg = _this$options.msg,
        duration = _this$options.duration,
        captureEvt = _this$options.captureEvt,
        withMask = _this$options.withMask;
    return h("div", [this.renderToast(type === 'default' ? h("p", {
      "class": "ui-toast",
      "directives": [{
        name: "show",
        value: this.show
      }]
    }, [msg || '']) : h("div", {
      "class": "ui-toast ui-toast-status",
      "directives": [{
        name: "show",
        value: this.show
      }]
    }, [h("div", {
      "class": "ui-toast-wrapper"
    }, [this.renderStatusContent()])])), h("div", {
      "directives": [{
        name: "show",
        value: this.show
      }],
      "class": ['ui-dialog-mask', {
        'ui-dialog-mask-noevent': duration && !captureEvt
      }],
      "style": {
        opacity: !withMask ? 0 : null
      },
      "on": {
        "click": this.onMaskClick
      }
    })]);
  }
};